import { SessionFilterViewProps } from './model'
import React, { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  selectSessionFilterMeetingKind,
  selectSessionFilterMeetingSources,
  setSessionFilterMeetingKind,
  setSessionFilterMeetingSources,
} from '../../store/sessionFilter/sessionFilter'
import { MultiSelectDropdown } from '../MultiSelectDropdown/MultiSelectDropdown'
import { useDebouncedCallback } from 'use-debounce'
import { useSearchParams } from 'react-router-dom'

export const SessionKindSourceFilter: React.FC<SessionFilterViewProps> = ({ disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const selectedMeetingKind = useAppSelector(selectSessionFilterMeetingKind)
  const selectedMeetingSource = useAppSelector(selectSessionFilterMeetingSources)
  const filterCount = (selectedMeetingKind ? 1 : 0) + selectedMeetingSource.length
  const [searchParams] = useSearchParams()

  const sourceOptions = [
    { id: 'meet', label: 'Google Meet' },
    { id: 'import', label: 'Import' },
    { id: 'voice-memo', label: 'In Person' },
    { id: 'teams', label: 'Microsoft Teams' },
    { id: 'phone', label: 'Phone' },
    { id: 'webex', label: 'Webex' },
    { id: 'zoom', label: 'Zoom' },
  ]

  const handleMeetingSourceChanged = useDebouncedCallback((options: string[]) => {
    const sources = options.filter((option) => sourceOptions.map((sourceOption) => sourceOption.id).includes(option))
    searchParams.delete('filterId')
    searchParams.delete('meetingKind')
    if (sources.length > 0) {
      searchParams.set('meetingSources', JSON.stringify(sources))
    } else {
      searchParams.delete('meetingSources')
    }
    dispatch(setSessionFilterMeetingKind(null))
    dispatch(setSessionFilterMeetingSources(sources))
    if (onFilterChanged) {
      onFilterChanged(searchParams)
    }
  }, 400)

  const selectedOptions = useMemo(() => {
    const optionsSet = new Set<string>()

    if (selectedMeetingKind === 'internal') {
      optionsSet.add('voice-memo')
    }

    selectedMeetingSource.forEach((source) => {
      optionsSet.add(source)
    })

    return Array.from(optionsSet)
  }, [selectedMeetingKind, selectedMeetingSource])

  return (
    <div>
      <div className='mb-1'>Filter by meeting source {filterCount ? <>({filterCount})</> : null}</div>
      <div className='d-flex gap-2'>
        <MultiSelectDropdown
          name='meetingSources'
          options={sourceOptions}
          initialSelectedOptions={selectedOptions}
          onSelectedChanged={handleMeetingSourceChanged}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
